/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectImageReference } from '../../models/project-image-reference';

export interface UpdateProjectImageReference$Params {
  projectId: string;
  id: string;
      body?: ProjectImageReference
}

export function updateProjectImageReference(http: HttpClient, rootUrl: string, params: UpdateProjectImageReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectImageReference>> {
  const rb = new RequestBuilder(rootUrl, updateProjectImageReference.PATH, 'put');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectImageReference>;
    })
  );
}

updateProjectImageReference.PATH = '/project/{projectId}/images/{id}';
